__turbopack_context__.v({
  "header": "UdSwda_header",
  "orderItem": "UdSwda_orderItem",
  "orderItemList": "UdSwda_orderItemList",
  "orderItemName": "UdSwda_orderItemName",
  "orderItemPrice": "UdSwda_orderItemPrice",
  "orderItemQty": "UdSwda_orderItemQty",
  "orderItemRight": "UdSwda_orderItemRight",
});
